import { requestPost, requestFormPost, requestGetFilterEmpty } from '@/common/request';

export default {
  // 素材维护消息触达维护（创建）
  // https://cf.jd.com/pages/viewpage.action?pageId=789895341
  async saveActivityData(data) {
    return await requestFormPost(`/generic/mac/activityMaterial/save`, data);
  },
  // 素材维护消息触达维护（查询）
  // https://cf.jd.com/pages/viewpage.action?pageId=789896439
  async getActivityData(activityId) {
    return await requestFormPost(`/generic/mac/activityMaterial/get`, { activityId });
  },
  // 素材维护消息触达（确认触达）
  // https://cf.jd.com/pages/viewpage.action?pageId=807867493
  async confirmSelection(data) {
    return await requestFormPost(`/generic/mac/activityMaterial/confirmSelection`, data);
  },
};
